// @ts-nocheck
import { JxsComponent } from "@jxs/component";
import { JxsSwiperSlideChange } from '@jxs/utilities';

const SPEED = 300;

class JxsBrandIntro extends JxsComponent {

  #brandSwiper = null;
  #brandSwiperSlideChange = null;

  #mainSwiper = null;
  #mainSwiperSlideChange = null;

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.initBrandSwiper();
    this.initMainSwiper();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#brandSwiper.destroy();
    this.#mainSwiper.destroy();
  }

  initBrandSwiper() {
    const wrapper = this.refs.brandSwiper.querySelector('.swiper-wrapper');
    this.refs.items.forEach((item, index) => {
      const img = item.querySelector('.jxs-brand-intro__image');
      if (img) {
        const swiperSlide = document.createElement('div');
        swiperSlide.dataset.brandIndex = index;
        swiperSlide.classList.add('swiper-slide');
        swiperSlide.append(img);
        if (img.hasAttribute('placeholder')) {
          img.textContent = (index + 1);
        }
        wrapper.append(swiperSlide);
      }
    });
    const clone = [];
    wrapper.querySelectorAll('.swiper-slide').forEach(slide => {
      clone.push(slide);
    });
    for (let i = 0; i < 3; i++) {
      clone.forEach(slide => {
        wrapper.append(slide.cloneNode(true));
      });
    }
    this.#brandSwiper = new window.Swiper(this.refs.brandSwiper, {
      loop: true,
      loopAdditionalSlides: 1,
      rewind: false,
      pagination: false,
      autoplay: false,
      slidesPerView: 'auto',
      spaceBetween: this.getDataset('mobileImageGap'),
      centeredSlides: true,
      slideToClickedSlide: true,
      speed: SPEED,
      breakpoints: {
        768: {
          spaceBetween: this.getDataset('imageGap')
        }
      }
    });
    this.#brandSwiperSlideChange = new JxsSwiperSlideChange(this.#brandSwiper)
    this.#brandSwiperSlideChange.addListener(this.#handleBrandSlideChange);
  }

  initMainSwiper() {
    let autoplay = false;
    const autoplaySec = this.getDataset('autoplaySec');
    if (autoplaySec > 0) {
      autoplay = {
        delay: autoplaySec * 1000
      }
    }
    this.#mainSwiper = new window.Swiper(this.refs.mainSwiper, {
      loop: true,
      rewind: false,
      pagination: false,
      autoplay: autoplay,
      slidesPerView: 1,
      loopAdditionalSlides: 1,
      spaceBetween: 0,
      speed: SPEED
    });
    this.#mainSwiperSlideChange = new JxsSwiperSlideChange(this.#mainSwiper)
    this.#mainSwiperSlideChange.addListener(this.#handleMainSlideChange);
  }

  #handleMainSlideChange = (swiper, prevIndex, destIndex, activeIndex) => {
    if (this.slideChanging) return;
    this.slideChanging = true;

    /*
      根据差值判断文案切换属于下一个还是上一个，然后计算图片的下一个真实下标。
      #不要怀疑为什么写的这么麻烦，因为swiper的loop + auto width + centerSlide三重buff就是路边一条。#
    */
    const diffIndex = destIndex - prevIndex;

    if (diffIndex == 1 || diffIndex < -1) {
      // slideToNext
      const realDestIndex = this.#brandSwiper.realIndex + 1;
      if (realDestIndex < this.#brandSwiper.slides.length) {
        this.#brandSwiper.slideToLoop(realDestIndex);
      } else {
        this.#brandSwiper.slideToLoop(0);
      }
    } else {
      const realDestIndex = this.#brandSwiper.realIndex - 1;
      if (realDestIndex >= 0) {
        this.#brandSwiper.slideToLoop(realDestIndex);
      } else {
        this.#brandSwiper.slideToLoop(this.#brandSwiper.slides.length - 1);
      }
    }

    setTimeout(() => {
      this.slideChanging = false;
    }, SPEED + 50);
  }

  #handleBrandSlideChange = (swiper, prevIndex, destIndex, activeIndex) => {
    if (this.slideChanging) return;
    this.slideChanging = true;
    const activeSlide = swiper.slides[activeIndex];
    
    this.#mainSwiper.slideToLoop(parseInt(activeSlide.dataset.brandIndex));

    setTimeout(() => {
      this.slideChanging = false;
    }, SPEED + 50);
  }

  slidePrev() {
    this.#brandSwiper.slidePrev();
  }
}
customElements.define('jxs-brand-intro', JxsBrandIntro);